import { getCurrentCurrencyCultureInfo, getCurrentNumberCultureInfo } from '@mews-commander/core/legacy-globalization';
import { Store } from '@mews-commander/types';
import { createCultureFormatRegex, NumberFormatting } from '@mews/framework';

/** @deprecated Only exported for the unit test */
export const createCultureFormattingValidator =
    (getCultureInfo: () => NumberFormatting) =>
    (value: string, { message = '', optional = false } = {}) => {
        if (optional && !value) {
            return null;
        }
        const regex = createCultureFormatRegex(getCultureInfo());
        return regex.test(value) ? null : message;
    };

export const createCultureFormatValidators = (store: Store) => ({
    formattedNumber: createCultureFormattingValidator(() => getCurrentNumberCultureInfo(store.getState())),
    formattedCurrency: createCultureFormattingValidator(() => getCurrentCurrencyCultureInfo(store.getState())),
});
